import React, { useState } from 'react';
import CaseTypeListHeader from '../ListHeader/CaseTypeListHeader';
import CaseTypeListItem from './CaseTypeListItem';
import useCaseTypeTree, {
	CaseTypeTreeItem,
} from '../../../Hooks/useCaseTypeTree';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import OverlayLoading from '../../../../../Components/OverlayLoading';
import CaseTypeOrganizationUnitModal from '../OrganizationUnit/CaseTypeOrganizationUnitModal';
import CaseTypeDetailModal from '../Detail/CaseTypeDetailModal';
import { CaseTypeType } from '../../../Enums/CaseTypeType.enum';

// @ts-ignore
import styles from './CaseTypeList.module.scss';

interface Props {
	workplaceId: string;
	healthPlanCode?: string;
}

const CaseTypeList: React.FC<Props> = ({ workplaceId, healthPlanCode }) => {
	const { caseTypeTree, isOnlyOneRoot, reFetch, isLoading } = useCaseTypeTree(
		workplaceId,
		healthPlanCode,
	);

	const [caseTypeId, setCaseTypeId] = useState<string | undefined>(undefined);
	const [organizationUnitId, setOrganizationUnitId] = useState<
		string | undefined
	>(undefined);

	const handleOrganizationUnitEditSuccess = async () => {
		setOrganizationUnitId(undefined);
		await reFetch();
	};

	const handleCaseTypeEditSuccess = async () => {
		setCaseTypeId(undefined);
		await reFetch();
	};

	const handleEdit = (item: CaseTypeTreeItem) => {
		if (item.caseType.type === CaseTypeType.CASE_TYPE) {
			setCaseTypeId(item.id);
		}
		if (item.caseType.type === CaseTypeType.FOLDER) {
			setOrganizationUnitId(item.id);
		}
	};

	return (
		<>
			<div className={styles.wrapper}>
				<CaseTypeListHeader
					workplaceId={workplaceId}
					reloadList={reFetch}
					isOnlyOneRoot={isOnlyOneRoot}
				/>
				<div className={styles.list}>
					{isLoading && <OverlayLoading />}
					<ScrollContainer className={styles.scrollContainer}>
						{caseTypeTree?.map(item => (
							<React.Fragment key={item.id}>
								<CaseTypeListItem item={item} onEdit={handleEdit} />
							</React.Fragment>
						))}
					</ScrollContainer>
				</div>
			</div>
			{organizationUnitId && (
				<CaseTypeOrganizationUnitModal
					isOpened
					onClose={() => setOrganizationUnitId(undefined)}
					workplaceId={workplaceId}
					organizationUnitId={organizationUnitId}
					onSuccess={handleOrganizationUnitEditSuccess}
					isOnlyOneRoot={isOnlyOneRoot}
				/>
			)}
			{caseTypeId && (
				<CaseTypeDetailModal
					isOpened
					onClose={() => setCaseTypeId(undefined)}
					workplaceId={workplaceId}
					caseTypeId={caseTypeId}
					onSuccess={handleCaseTypeEditSuccess}
					isOnlyOneRoot={isOnlyOneRoot}
				/>
			)}
		</>
	);
};

export default CaseTypeList;
